import { of } from "rxjs";
import { actionCultivateRequest } from "../actionNursery";
export var pathNurseryCultivate = function (action, state$, deps) { return of(actionCultivateRequest(action.recipe)); };



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/paths/pathNurseryCultivate.ts
// module id = 2030
// module chunks = 3